import script from "./FAQComp.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQComp.vue?vue&type=script&setup=true&lang=js"

import "./FAQComp.vue?vue&type=style&index=0&id=44496af5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44496af5"]])

export default __exports__